import { BankSEOConfig } from '../types';
import defaultConfig from './config.default';

const bankName = 'Sparekassen Sjælland-Fyn';

const config: BankSEOConfig = {
  ...defaultConfig,
  fullBankName: bankName,
  branchOverviewPage: {
    title:
      'Kort over Sparekassen Sjælland-Fyns filialer | Find en filial nær dig',
    description:
      ' Sparekassen Sjælland-Fyn åbner filialer, hvor andre lukker. Klik her, og find en filial i dit lokalområde.'
  }
};

export default config;
